import React from 'react';
import { Section } from './ui/Section';
import { Shield, Brain, Target, Users } from 'lucide-react';
const values = [{
  icon: Brain,
  title: 'Unshakable Confidence',
  description: "Watch your child's self-esteem soar as they overcome challenges and master new skills."
}, {
  icon: Target,
  title: 'Laser Focus',
  description: 'Our structured curriculum improves concentration, leading to better grades and behavior.'
}, {
  icon: Shield,
  title: 'Real Self-Defense',
  description: 'Practical, effective techniques that keep students safe without promoting aggression.'
}, {
  icon: Users,
  title: 'Discipline & Respect',
  description: 'Traditional values of respect for self and others are woven into every single class.'
}];
export function ValueProps() {
  return <Section data-id="element-145">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-146">
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-147">
          More Than Just Kicks & Punches
        </h2>
        <p className="text-lg text-gray-600" data-id="element-148">
          We use martial arts as a vehicle to develop the character traits that
          lead to success in life.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-149">
        {values.map((value, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow duration-300 flex flex-col items-center text-center" data-id="element-150">
            <div className="w-14 h-14 bg-red-50 text-red-600 rounded-xl flex items-center justify-center mb-6" data-id="element-151">
              <value.icon className="w-7 h-7" data-id="element-152" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-153">
              {value.title}
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-154">{value.description}</p>
          </div>)}
      </div>
    </Section>;
}